import {useSelector} from 'react-redux'

import {LegalLang, toLegalLang} from '../../legal/legal-helpers'
import {GlobalService} from '../../services/global'

/** The kit language that matches the app language chosen in the profile menu. */
export const useLegalLang = (): LegalLang => toLegalLang(useSelector(GlobalService.selectors.language()))
